// extracted by mini-css-extract-plugin
export var grid = "_20-0";
export var span1 = "_20-2";
export var span10 = "_20-b";
export var span10L = "_20-z";
export var span10M = "_20-n";
export var span10Xl = "_20-1b";
export var span11 = "_20-c";
export var span11L = "_20-10";
export var span11M = "_20-o";
export var span11Xl = "_20-1c";
export var span12 = "_20-d";
export var span12L = "_20-11";
export var span12M = "_20-p";
export var span12Xl = "_20-1d";
export var span1L = "_20-q";
export var span1M = "_20-e";
export var span1Xl = "_20-12";
export var span2 = "_20-3";
export var span2L = "_20-r";
export var span2M = "_20-f";
export var span2Xl = "_20-13";
export var span3 = "_20-4";
export var span3L = "_20-s";
export var span3M = "_20-g";
export var span3Xl = "_20-14";
export var span4 = "_20-5";
export var span4L = "_20-t";
export var span4M = "_20-h";
export var span4Xl = "_20-15";
export var span5 = "_20-6";
export var span5L = "_20-u";
export var span5M = "_20-i";
export var span5Xl = "_20-16";
export var span6 = "_20-7";
export var span6L = "_20-v";
export var span6M = "_20-j";
export var span6Xl = "_20-17";
export var span7 = "_20-8";
export var span7L = "_20-w";
export var span7M = "_20-k";
export var span7Xl = "_20-18";
export var span8 = "_20-9";
export var span8L = "_20-x";
export var span8M = "_20-l";
export var span8Xl = "_20-19";
export var span9 = "_20-a";
export var span9L = "_20-y";
export var span9M = "_20-m";
export var span9Xl = "_20-1a";
export var stretch = "_20-1";